import { useState } from 'react';
import { video } from "shared/types/Report";
import useBatchView, { parseBatchLines } from './useBatchView';
import useStorage from "shared/hooks/useStorage";

const useVideoBatchView = (list: video[], setList:React.Dispatch<React.SetStateAction<video[]>>, path:string, onCloseViewHandler:()=>void) => {
    const baseHook = useBatchView(list, setList, path);
    const {uploadStorage} = useStorage();
    const [videoList, setVideoList] = useState<File[]>([]);
    const [titleList, setTitleList] = useState<string[]>([]);
    const [exampleList, setExampleList] = useState<string[]>([]);
    const onChangeInputHandler = (name: string, value: string) => {
        const valueList = parseBatchLines(value);
        if(name === "title"){
            setTitleList(valueList);
        } else if(name === "example"){
            setExampleList(valueList);
        }
    };

    const onRegisterReportClickHandler = async(list:video[]) => {
        let data = await registerImage(list);
        data = baseHook.removeKeyFromObjects(data, "video_non_audio_preview");
        const register_data = baseHook.removeKeyFromObjects(data, "video_preview");
        baseHook.onRegisterReportClick("video", register_data);
    }

    const registerImage = async(list:video[]) => {
        let newList = list;
        baseHook.setShowProgress(true);
        for(let i = 0; i < list.length; i++){
            const video = list[i].video;
            const non_audio_video = list[i].video_non_audio;
            if (video instanceof File) {
                baseHook.setUploadFileName(video.name);
                const video_url = await uploadStorage(path + "/video", video, baseHook.setProgress).then(res => {
                    return res || "";
                })
                newList[i].video = video_url;
                newList[i].video_preview = "";
            }
        }
        baseHook.setShowProgress(false);
        setList(newList);
        return newList;
    }

    const onSaveClickHandler = () => {
        if(!(videoList.length === titleList.length)){
            baseHook.openCountMismatchError();
            return;
        }
        const newList:video[] = [];
        for(let i = 0; i < videoList.length; i++){
            newList.push({id:i + 1, title:titleList[i], example:exampleList[i] || "", video:videoList[i], video_non_audio:"", read_only:false});
        }
        onRegisterReportClickHandler(newList);
    }

    const onSuccessModalConfirmHandler = () => {
        baseHook.onSuccessModalConfirmHandler();
        onCloseViewHandler();
    }


    return {...baseHook, videoList, setVideoList, exampleList, setExampleList, onChangeInputHandler, onSaveClickHandler, onSuccessModalConfirmHandler};
};

export default useVideoBatchView;
